import Grid from '@mui/material/Grid';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField';
import { useTranslation } from 'react-i18next';
import type { BannerCreativeFormData } from '../validation/bannerCreative';

export const BannerDimensions = () => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid size={6}>
        <RHFTextField
          name={'width' satisfies keyof BannerCreativeFormData}
          label={t('Dimension - Width')}
          placeholder={t('Enter Width')}
          fullWidth
          dataTest="creative-width"
          margin="dense"
        />
      </Grid>

      <Grid size={6}>
        <RHFTextField
          name={'height' satisfies keyof BannerCreativeFormData}
          label={t('Dimension - Height')}
          placeholder={t('Enter Height')}
          fullWidth
          dataTest="creative-height"
          margin="dense"
        />
      </Grid>
    </Grid>
  );
};
